<template>
  <div class="card mb-25 border-0 rounded-0 bg-white recent-activity-box">
    <div class="card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing">
      <div
        class="mb-15 mb-md-20 mb-xxxl-25 d-flex align-itemsh5s-center justify-content-between"
      >
        <h5 class="card-title fw-bold mb-0">Recent Activity</h5>
      </div>
      <ul class="list ps-0 mb-0 list-unstyled">
        <li
          class="position-relative fw-medium text-dark-emphasis"
          v-for="item in rows"
          :key="item.id"
        >
          <div
            class="icon position-absolute start-0 rounded-circle text-center"
          >
            <i class="ph-duotone ph-check-circle"></i>
          </div>
          <span class="text-black fw-bold">{{ item.task_type }}</span
          ><br />
          {{ item.task }}
          <span class="d-block fs-13 mt-1">{{ getDate(item.created_at) }}</span>
          
        </li>
      </ul>
    </div>
    <div class="pagination">
      <button
        :disabled="filter.current_page === 1"
        @click="changePage(filter.current_page - 1)"
      >
        Prev
      </button>

      <!-- First page -->
      <button v-if="startPage > 1" @click="changePage(1)">1</button>
      <span v-if="startPage > 2">...</span>

      <!-- Middle pages -->
      <button
        v-for="page in pagesToShow"
        :key="page"
        :class="{ active: page === filter.current_page }"
        @click="changePage(page)"
      >
        {{ page }}
      </button>

      <!-- Last page -->
      <span v-if="endPage < totalPages">...</span>
      <button v-if="endPage < totalPages" @click="changePage(totalPages)">
        {{ totalPages }}
      </button>

      <button
        :disabled="filter.current_page === totalPages"
        @click="changePage(filter.current_page + 1)"
      >
        Next
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { reactive, ref, computed, defineComponent, onMounted } from "vue";
import api from "@/utils/axios";
import moment from "moment";

export default defineComponent({
  props: { userId: { type: String, required: true } },
  setup(props) {
    const rows = ref<any[]>([]);
    const filter = reactive({
      total: 0,
      per_page: 10,
      current_page: 1,
      searchTerm: "",
      searchType: "",
      searchSDate: "",
      searchEDate: "",
    });

    const totalPages = computed(() =>
      Math.ceil(filter.total / filter.per_page)
    );

    const maxButtons = 5; // how many pages to show around current

    const startPage = computed(() =>
      Math.max(filter.current_page - Math.floor(maxButtons / 2), 1)
    );
    const endPage = computed(() =>
      Math.min(startPage.value + maxButtons - 1, totalPages.value)
    );

    const pagesToShow = computed(() => {
      const pages: number[] = [];
      for (let i = startPage.value; i <= endPage.value; i++) {
        pages.push(i);
      }
      return pages;
    });

    const fetchData = async () => {
      try {
        const res = await api.get(`/api/auth/HistoriesUser/${props.userId}`, {
          params: {
            searchTerm: filter.searchTerm,
            searchType: filter.searchType,
            searchSDate: filter.searchSDate,
            searchEDate: filter.searchEDate,
            page: filter.current_page,
            per_page: filter.per_page,
          },
        });
        rows.value = res.data.users.data;
        Object.assign(filter, res.data.users);
      } catch (error) {
        console.error(error);
      }
    };

    const changePage = (page: number) => {
      if (page < 1 || page > totalPages.value) return;
      filter.current_page = page;
      fetchData();
    };

    onMounted(fetchData);

    const getDate = (value: any) =>
      moment.utc(String(value)).format("YYYY-MM-DD HH:mm");

    return {
      filter,
      rows,
      totalPages,
      startPage,
      endPage,
      pagesToShow,
      changePage,
      getDate,
    };
  },
});
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  gap: 5px;
  padding: 10px;
}
button {
  padding: 5px 10px;
  border: 1px solid #ddd;
  background: white;
  cursor: pointer;
}
button.active {
  background: #007bff;
  color: white;
  font-weight: bold;
}
button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>